import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../config/firebaseConfig";
import { useAuthState } from "react-firebase-hooks/auth";
import { LoadingDots } from "../components";
import { useSelector } from "react-redux";
const UserAuthProtected = ({ children, authenticate = true }) => {
  const [userAuth, authLoading] = useAuthState(auth);
  const navigate = useNavigate();
  const { userDetails, loading: userDetailsLoading } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (!authLoading) {
      if (authenticate && !userAuth) {
        navigate("/login");
      } else if (!authenticate && userAuth) {
        if (userDetailsLoading) {
        } else {
          userDetails?.accountType === "school"
            ? navigate("/schoolDashboard")
            : userDetails?.accountType === "parent"
            ? navigate("/parentDashboard")
            : console.log("test");
        }
      }
    }
  }, [
    authenticate,
    navigate,
    authLoading,
    userAuth,
    userDetails,
    userDetailsLoading,
  ]);

  return authLoading || userDetailsLoading ? <LoadingDots /> : children;
};

export default UserAuthProtected;
